import { render, staticRenderFns } from "./ImporteTotal.vue?vue&type=template&id=523783c0&"
import script from "./ImporteTotal.vue?vue&type=script&lang=js&"
export * from "./ImporteTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports